export default {
  loading: state => state.loading,
  isEditing: state => state.isEditing,
  isComingFromSchedule: state => state.isComingFromSchedule,
  flow: state => state.flow,
  skipCoverage: state => state.skipCoverage,
  skipCredit: state => state.skipCredit,
  skipBiometry: state => state.skipBiometry,
  saleToEditId: state => state.saleToEditId,
  selectedOfferId: state => state.selectedOfferId,
  origin: state => state.origin,
  saleId: state => state.saleId,
  saleCode: state => state.saleCode,
  saleDate: state => state.saleDate,
  saleHistory: state => state.saleHistory,
  saleSeller: state => state.saleSeller,
  saleUuid: state => state.uuid,
  coverageStatus: state => state.coverageStatus,
  saleStatus: state => state.status,
  saleSubStatus: state => state.subStatus,
  qrcode: state => state.qrcode,
  getSaleItemUuid: state => state.saleItemUuid,
  getFromVisit: state => state.fromVisit,
  getRules: state => state.rules,
  getDataToTransform: state => state.dataToTransform,
  getNote: state => state.note,
  getProviderSaleFlows: state => state.providerSaleFlows,
  getSelectedRoutes: state => state.selectedRoutes,
  getSelectedProviderSaleFlow: state => state.selectedProviderSaleFlow,
  getHasCaptation: state => state.hasCaptation,
  getHasCtos: state => state.hasCtos,
  getCanMovePin: state => state.canMovePin,
  getHasToChangeFlowByRole: state => state.hasToChangeFlowByRole,
  getDeactivatedEditFlowToUse: state => state.deactivatedEditFlowToUse,
  getPersonType: state => state.personType,
  getBePeopleSearch: state => state.bePeopleSearch,
  getAllowAddResponsibles: state => state.allowAddResponsible,
  getOnlyQualifiedResponsibles: state => state.onlyQualifiedResponsibles,
  getBlockDuplicatedCustomerContacts: state => state.blockDuplicatedCustomerContacts
}
